export default __webpack_public_path__ + "static/media/lock.cb053aa7.jpg";